export const RESET_MI_DASHBOARD = 'RESET_MI_DASHBOARD';

function clearMiDashboardData() {
  return {
    type: RESET_MI_DASHBOARD,
    isDateRangePickerShown: false,
    isGettingMiDashboard: false,
    isGettingMiDashboardXls: false,
    dateRangeFrom: '',
    dateRangeTo: '',
    miData: null,
    error: null
  };
}

export function resetMiDashboard() {
  return (dispatch) => {
    dispatch(clearMiDashboardData());
  };
}
